import { classes } from '../text-field/text-field.st.css';
import { FIELD_TYPES } from '../../constants';
import { getNumberInputError, isNumberInputValid } from '../../fields/number-input/number-input-utils';
import { FIELD_ERROR_CLASS, useError } from '../../field-error';
import { useFieldValidation } from '../../contexts/field-validation-context';
import { useConfig } from '../../contexts/config-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { useStyleParams } from '../../contexts/style-params-context';
import React, { useCallback, useMemo } from 'react';
import { getIsBorderStyleNone, getTextInputTheme } from '../text-field/utils';
import { TextField as TPATextField } from 'wix-ui-tpa/cssVars';
import classNames from 'classnames';
import { FieldLabel } from '../field-label/field-label';
import FieldDescription from '../field-description';
export const NumberInputComponent = _ref => {
  var _validation$number, _validation$number2, _validation$number3;
  let {
    path,
    value,
    validation,
    required,
    label,
    hideLabel,
    disabled,
    placeholder,
    onChange,
    onBlur,
    description,
    onFocus,
    error,
    customErrors,
    fieldType = FIELD_TYPES.NUMBER_INPUT
  } = _ref;
  const _error = getNumberInputError(validation, error);
  const {
    hasError,
    errorMessage
  } = useError(_error, customErrors, fieldType);
  const {
    validateFields
  } = useFieldValidation();
  const {
    isMobile
  } = useConfig();
  const multipleOf = (validation == null || (_validation$number = validation.number) == null ? void 0 : _validation$number.multipleOf) || 1;
  let maximum = validation == null || (_validation$number2 = validation.number) == null ? void 0 : _validation$number2.maximum;
  let minimum = validation == null || (_validation$number3 = validation.number) == null ? void 0 : _validation$number3.minimum;
  // Fixes types mismatch for Wix UI TPA
  minimum = minimum === null ? undefined : minimum;
  maximum = maximum === null ? undefined : maximum;
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const styleParams = useStyleParams();
  const theme = useMemo(() => getTextInputTheme({
    styleParams,
    mobile: isMobile
  }), [styleParams, isMobile]);
  const isBorderStyleNone = useMemo(() => getIsBorderStyleNone({
    styleParams,
    mobile: isMobile
  }), [styleParams, isMobile]);
  const numberOnChange = useCallback(event => {
    const rawValue = event.target.value;
    if (rawValue === '') {
      // allow clear input
      onChange(rawValue);
      return;
    }
    const newValue = Number(rawValue);
    const validValue = isNumberInputValid(newValue, multipleOf) ? newValue : value;
    onChange(validValue);
    if (hasError) {
      validateFields({
        path,
        value: validValue
      });
    }
  }, [onChange, multipleOf, value, hasError, path, validateFields]);
  const handleBlur = useCallback(event => {
    const newValue = event.target.value === '' ? null : Number(event.target.value);
    onChange(newValue);
    validateFields({
      path,
      value: newValue
    });
    onBlur == null || onBlur();
  }, [path, onChange, validateFields, onBlur]);
  return /*#__PURE__*/React.createElement(FieldDescription, {
    description: description
  }, /*#__PURE__*/React.createElement(TPATextField, {
    type: "number",
    error: hasError,
    errorMessage: errorMessage,
    newErrorMessage: true,
    value: typeof value === 'number' ? String(value) : value,
    className: classNames(classes.root, {
      [FIELD_ERROR_CLASS]: hasError,
      [classes.noBorder]: isBorderStyleNone,
      [classes.hover]: forcedHover
    })
    // @ts-expect-error
    ,
    label: /*#__PURE__*/React.createElement(FieldLabel, {
      required: required,
      label: label,
      hideLabel: hideLabel
    }),
    onChange: numberOnChange,
    disabled: disabled,
    placeholder: placeholder,
    min: minimum,
    max: maximum,
    onBlur: handleBlur,
    onFocus: onFocus,
    "aria-label": label,
    step: multipleOf,
    theme: theme
  }));
};
//# sourceMappingURL=number-input-component.js.map